import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
class DiagramDosenSertifikasi extends Component {
  options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
        },
      ],
    },
  };
  render() {
    let data = this.props.dataDosen?.data_dosen_dosen_sertifikasi?.[0] || {};
    let data_dosen = this.props.dataDosen?.jumdosen || {};
    let i = 0;
    let ii = 0;
    let year = [];
    let dosen_ser = [];
    let jum_dosen = [];
    for (var key in data) {
      year[i] = key;
      dosen_ser[i] = data[key];
      i++;
    }
    for (var key in data_dosen) {
      jum_dosen[ii] = data_dosen[key];
      ii++;
    }
    let sertifikasi_dosen = {
      labels: year,
      datasets: [
        {
          type: "bar",
          label: "Dosen",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#b2ddeb",
          borderColor: "#b2ddeb",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#b2ddeb",
          pointBackgroundColor: "#fff",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#b2ddeb",
          pointHoverBorderColor: "#b2ddeb",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: dosen_ser,
        },
        {
          type: "line",
          label: "Jumlah Dosen",
          fill: false,
          lineTension: 0.1,
          borderColor: "rgba(3, 66, 99)",
          borderColor: "rgba(3, 66, 99)",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "rgba(3, 66, 99)",
          pointBackgroundColor: "rgba(3, 66, 99)",
          pointBorderWidth: 5,
          pointHoverRadius: 10,
          pointHoverBackgroundColor: "rgba(3, 66, 99)",
          pointHoverBorderColor: "rgba(3, 66, 99)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: jum_dosen,
        },
      ],
    };
    return (
      <>
        <div className={`card-custom`}>
          {/* Header */}
          <div
            className="card-header border-0"
            style={{ textAlign: "center", paddingBottom: "0px" }}
          >
            <h5
              className="card-title font-weight-bolder"
              style={{ color: "#354f7a" }}
            >
              Dosen Sertifikasi
            </h5>
          </div>

          {/* Body */}
          <div className="card-body pt-2">
            <Bar data={sertifikasi_dosen} options={this.options} />
          </div>
        </div>
      </>
    );
  }
}
export default DiagramDosenSertifikasi;
